import LegalLayout from './components/LegalLayout';

const sections = [
  {
    title: '個人情報の取得と利用目的',
    body: '当サイトでは、お問い合わせフォーム、コメント、各種サービス利用時に、名前・メールアドレスなどの個人情報を取得する場合があります。取得した情報は以下の目的で利用します。',
    items: [
      'お問い合わせへの回答',
      'サービス改善のための分析',
      '不正アクセス防止・セキュリティ対策',
      '必要に応じたご連絡',
    ],
  },
  {
    title: '個人情報の第三者提供',
    body: '取得した個人情報は、法令に基づく場合を除き、第三者に提供することはありません。',
  },
  {
    title: 'アクセス解析ツールについて',
    body: '当サイトでは、Google Analyticsなどのアクセス解析ツールを使用しています。\nこれらのツールはトラフィックデータ収集のためにCookieを使用しますが、匿名で収集され、個人を特定するものではありません。',
  },
  {
    title: '広告配信について',
    body: '当サイトでは、第三者配信の広告サービス（Googleアドセンス等）を利用する場合があります。\n広告配信事業者は、ユーザーの興味に応じた広告を表示するためにCookieを使用することがあります。',
  },
  {
    title: '個人情報の開示・訂正・削除',
    body: '本人からの請求があった場合、適切に対応します。\nお問い合わせは当サイト内のフォームよりご連絡ください。',
  },
  {
    title: '著作権について',
    body: '当サイトに掲載されている文章・画像・図解の著作権は「鳥取ではじめての家づくり」運営者に帰属します。\n無断転載・無断使用を禁止します。',
  },
  {
    title: 'プライバシーポリシーの変更',
    body: '必要に応じて内容を変更する場合があります。変更後のポリシーは本ページに掲載された時点で効力を持ちます。',
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout
      title="プライバシーポリシー"
      subtitle="鳥取ではじめての家づくり"
      lastUpdated="2026年3月"
      sections={sections}
    />
  );
}
